<template>
  <div class="home">
    <error-message />
    <v-checkbox
      v-model="loginDialog"
      label="ログインテスト"
      v-show="!loginDialog"
      v-if="false"
    >
    </v-checkbox>
    <v-container fluid>
      <!-- 情報集約機能 -->
      <v-row justify="center" align="center">
        <v-col cols="12" sm="12" md="4" lg="4">
          <v-card color="primary" dark to="/aggregation-menu">
            <v-card-text class="display-1 text-left"
              ><br /><span style="position: relative;bottom: 1.25rem;"
                >情報集約機能</span
              >
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="5">
          災害や訓練をシステムへ登録し、住民の避難を誘導するための機能を使う場合に押下します
        </v-col>
      </v-row>
      <!-- 住民向けアプリ概要  -->
      <v-row justify="center" align="center">
        <v-col cols="12" sm="12" md="4" lg="4">
          <v-card
            color="primary"
            dark
            :href="`${homeUrl}/manual/manual_jyumin_all.pdf`"
            target="_blank"
          >
            <v-card-text class="display-1 text-left"
              >住民向けアプリ<br />・概要<br />・インストール手順<br />・操作手順
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="5">
          住民向けアプリの概要やインストール手順、操作手順を確認する場合に押下します
        </v-col>
      </v-row>
      <!-- 防災関係者向けアプリ概要  -->
      <v-row justify="center" align="center">
        <v-col cols="12" sm="12" md="4" lg="4">
          <v-card
            color="primary"
            dark
            :href="`${homeUrl}/manual/manual_bousai_all.pdf`"
            target="_blank"
          >
            <v-card-text class="display-1 text-left"
              >防災関係者向けアプリ<br />・概要<br />・インストール手順<br />・操作手順
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="5">
          防災関係者向けアプリの概要やインストール手順、操作手順を確認する場合に押下します
        </v-col>
      </v-row>
    </v-container>
    <v-dialog max-width="450" v-model="loginDialog" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">ログイン</span>
        </v-card-title>
        <v-container>
          <v-row class="ml-2">
            <v-col cols="5">ID</v-col>
            <v-col>
              <input
                v-model="loginID"
                type="text"
                style="border: 1px solid; border-radius: 0.3em;"
              />
            </v-col>
          </v-row>
          <v-row class="ml-2">
            <v-col cols="5">パスワード</v-col>
            <v-col>
              <input
                v-model="loginPW"
                type="password"
                style="border: 1px solid; border-radius: 0.3em;"
              />
              <v-checkbox
                label="ログインIDを保存する"
                style="mt-1"
                v-model="loginSaveState"
                @change="saveLogin"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="ml-2">
            <v-card-text style="padding-top:0;padding-bottom:0"
              >パスワードを忘れた場合は、管理者にお問い合わせください。</v-card-text
            >
            <v-card-text v-if="inputError" style="color: #ff0000;">
              {{ ErrorTodoMessages.ERWE40001 }}
            </v-card-text>
            <v-card-text v-if="authError" style="color: #ff0000;">
              {{ ErrorTodoMessages.ERWE40002 }}
            </v-card-text>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="login()" :loading="loading">
            ログイン
          </v-btn>
          <v-btn color="blue darken-1" text @click="cleartext()">
            クリア
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Vue from "vue";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import screenAuthority from "@/plugins/screen-authority";
import { ScreenId } from "@/js/value-objects/screen-id";
import handleError from "@/mixins/handle-error";
import ErrorMessage from "@/components/ErrorMessage";
import { ErrorTodoMessages } from "@/js/constants/error-messages";
import cognito from "@/js/cognito";

Vue.use(screenAuthority);

const screenAuthorityRepository = RepositoryFactory.get("screenAuthority");
const SCREEN_ID = ScreenId.SF0101;

export default {
  mixins: [handleError],

  components: {
    ErrorMessage
  },

  data: () => ({
    loginDialog: false, // ログインダイアログ表示有無
    loginID: "",
    loginPW: "",
    loginSaveState: false, // ログインID保存有無
    inputError: false, // ID,PW未入力エラーメッセージ表示有無
    authError: false, // ログイン失敗エラーメッセージ表示有無
    overlay: false,
    loading: false, // ログインボタンのIndicator
    homeUrl: "",
    ErrorTodoMessages // 共通エラーメッセージ
  }),

  watch: {
    $route: "initialize"
  },

  mounted() {
    this.pageTitle();
  },

  created() {
    this.initialize();
  },

  methods: {
    /**
     * ホーム画面が描画される度に実行される
     */
    async initialize(isAfterLoggedIn = false) {
      // PDF表示用のURL設定
      this.homeUrl = process.env.VUE_APP_SAFER_DOMAIN;

      // 以前ログインIDを保存した場合の初期化
      const LOCAL_SAVE_ID = localStorage.getItem("safer_user_id");
      if (LOCAL_SAVE_ID) {
        this.loginID = LOCAL_SAVE_ID;
        this.loginSaveState = true;
      }
      this.overlay = true;

      // cognitoでログイン情報をチェック
      cognito
        .isAuthenticated()
        .then(async () => {
          // cognitoのログイン情報が正しい

          // 画面権限取得
          await screenAuthorityRepository
            .list()
            .then(response => {
              const { data } = response;
              this.$screenAuthority = data.results;
            })
            .catch(error => {
              this.handleError(error, SCREEN_ID, "error");
            });

          // 災害情報取得
          // ログイン処理が成功した時のみ実行される
          if (isAfterLoggedIn) {
            await Promise.all([
              this.$store.dispatch("disasterInfo/loadLatestDisaster", SCREEN_ID)
            ]).catch(error => {
              this.handleError(error, SCREEN_ID, "error");
            });
          }
        })
        .catch(() => {
          // cognitoのログイン情報が正しくない
          // cognitoのログイン情報が存在しない
          this.loginDialog = true; // ログインダイアログを表示
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    /**
     * ログイン
     */
    login() {
      this.inputError = false; // 未入力エラーメッセージ表示有無
      this.authError = false; // ログイン失敗エラーメッセージ表示有無

      // ID,PWの未入力チェック
      if (!this.loginID || !this.loginPW) {
        this.inputError = true;
        return false;
      }

      this.loading = true; //ログインボタンのindicator表示

      //ログイン処理
      this.$cognito
        .login(this.loginID, this.loginPW, this.loginSaveState)
        .then((result) => { // eslint-disable-line
          let url = this.$route.query.redirect;
          if (
            url &&
            (url.substring(0) !== "/" || url.substring(0, 2) === "//")
          ) {
            this.$router.replace(url);
          }
          // ログイン成功後,ログイン画面初期化
          this.loginID = "";
          this.loginPW = "";
          this.loginSaveState = false;
          this.authError = false;
          this.loginDialog = false;
          this.initialize(true);
        })
        .catch(() => {
          this.authError = true; // ログイン失敗エラーメッセージ表示
        })
        .finally(() => {
          this.inputError = false;
          this.loading = false; //ログインボタンのindicator非表示
        });
    },

    // 入力したIDとパスワードの保存有無
    saveLogin(isClicked) {
      this.loginSaveState = isClicked ? true : false;
    },

    cleartext() {
      this.loginPW = "";
    }
  }
};
</script>
